module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar usage = (config || {}).usage || 'management';\nvar insertGranted = (config || {}).insertGranted;\nif(insertGranted === undefined) insertGranted = true;\nvar entityContext = (config || {}).entityContext || 'address';\nvar entityContextPlural = entityContext;\nif(entityContextPlural === 'address') entityContextPlural = 'addresses'\nvar exportGranted = false;\nif((storage || {}).user){\nexportGranted = storage.user.hasRoleOption('exportGranted', (config || {}).roleOptionScope || 'art_form');\n}\nvar deleteGranted = false;\nif((storage || {}).user) {\ndeleteGranted = storage.user.hasAccessTo(config.privilegeBase + ':delete', (config || {}).roleOptionScope || 'art_form');\n}\n%>\n<div>\n<%\nif(usage === 'management'){\n%>\n<section class=\"top\">\n<section class=\"left\">\n<h1><%= storage.__(config.titleKey || ''); %></h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n<%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }); %>\n<%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'setProcessed', context: entityContext, symbolOnly: false, icon: 'fi fi-check' } }); %>\n<%\nif(deleteGranted){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: entityContextPlural, symbolOnly: false, negative: true } }); %><%\n}\nif(exportGranted){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'export', context: entityContext, symbolOnly: false } }); %><%\n}\nif(insertGranted){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: entityContext, symbolOnly: false, positive: true } }); %><%\n}\n%>\n</section>\n</section>\n<%\n}\n%>\n<section class=\"bottom\">\n<%- helpers.renderSection('filter') %>\n<%- helpers.renderSection('list') %>\n</section>\n</div>"
  , __filename = "components/templates/artForm/entity/controller.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var usage = (config || {}).usage || 'management';
var insertGranted = (config || {}).insertGranted;
if(insertGranted === undefined) insertGranted = true;
var entityContext = (config || {}).entityContext || 'address';
var entityContextPlural = entityContext;
if(entityContextPlural === 'address') entityContextPlural = 'addresses'
var exportGranted = false;
if((storage || {}).user){
exportGranted = storage.user.hasRoleOption('exportGranted', (config || {}).roleOptionScope || 'art_form');
}
var deleteGranted = false;
if((storage || {}).user) {
deleteGranted = storage.user.hasAccessTo(config.privilegeBase + ':delete', (config || {}).roleOptionScope || 'art_form');
}

    ; __line = 16
    ; __append("\n<div>\n")
    ; __line = 18
    ; 
if(usage === 'management'){

    ; __line = 20
    ; __append("\n<section class=\"top\">\n<section class=\"left\">\n<h1>")
    ; __line = 23
    ; __append(escapeFn( storage.__(config.titleKey || '') ))
    ; __append("</h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n")
    ; __line = 27
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }) )
    ; __append("\n")
    ; __line = 28
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'setProcessed', context: entityContext, symbolOnly: false, icon: 'fi fi-check' } }) )
    ; __append("\n")
    ; __line = 29
    ; 
if(deleteGranted){

    ; __line = 31
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: entityContextPlural, symbolOnly: false, negative: true } }) )
    ; 
}
if(exportGranted){

    ; __line = 34
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'export', context: entityContext, symbolOnly: false } }) )
    ; 
}
if(insertGranted){

    ; __line = 37
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: entityContext, symbolOnly: false, positive: true } }) )
    ; 
}

    ; __line = 39
    ; __append("\n</section>\n</section>\n")
    ; __line = 42
    ; 
}

    ; __line = 44
    ; __append("\n<section class=\"bottom\">\n")
    ; __line = 46
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 47
    ; __append( helpers.renderSection('list') )
    ; __append("\n</section>\n</div>")
    ; __line = 49
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/artForm/entity/controller.ejs

}